<div class="container-parent-centered">
    <div class="container">

        <div class="container-app">
            <div class="payment-page" *ngIf="type=='paymentPage'">

                <div class="logo-container">
                    <img class="logo" src='{{payloadData.logoUrl}}'>
                </div>

                <div class="amount-due-and-message">
                    <div class="amount-due-line"><span class="amount-due-number">Amount Due: {{payloadData.amountDue | currency}}</span></div>
                    <div class="to-pay-text">To pay your balance, please enter <br> your card information below.</div>
                </div>

                <div class="credit-card">
                    <div class="cc-logo-row">
                        <img src="ui/assets/img/otp/amex.svg" *ngIf="payloadData.acceptAmex == 'Y'" class='cclogos'>
                        <img src="ui/assets/img/otp/mastercard.svg" *ngIf="payloadData.acceptMastercard == 'Y'"
                            class='cclogos'>
                        <img src="ui/assets/img/otp/visa.svg" *ngIf="payloadData.acceptVisa == 'Y'" class='cclogos'>
                        <img src="ui/assets/img/otp/discover.svg" *ngIf="payloadData.acceptDiscover == 'Y'"
                            class='cclogos'>
                        <img src="ui/assets/img/otp/applepay.svg" class='cclogos'>
                        <img src="ui/assets/img/otp/googlepay.svg" class='cclogos'>
                    </div>


                    <div class="form-group">
                        <div id="ccName" class="form-input" [ngClass]="{'form-error': cardErr.checkname.flag && isSubmitted == false}">
                        </div>
                    </div>
                    <div class="form-group">
                        <div id="ccNumber" class="form-input" [ngClass]="{'form-error': cardErr.ccnumber.flag && isSubmitted == false}">
                        </div>
                    </div>
                    <div class="cc-cvv">
                        <div class="form-group">
                            <div id="ccExp" class="form-input" [ngClass]="{'form-error': cardErr.ccexp.flag && isSubmitted == false}">
                            </div>
                        </div>

                        <div class="form-group">
                            <div id="cvv" class="form-input" [ngClass]="{'form-error': cardErr.cvv.flag && isSubmitted == false}"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <input name="billing-postal" class="form-custom" type="tel" placeholder="ZIP Code" maxlength="5"
                            value={{paymentData.zipCode}} [(ngModel)]="paymentData.zipCode" #zipCode="ngModel" zipCode
                            required
                            [ngClass]="{'form-custom-error': isSubmitted == false && zipCode.invalid && zipCode.touched}"
                            [maxlength]="5" [minlength]="5">
                    </div>

                    <div class="terms">
                        <label for="agree1">
                            <input name="agree1" id="checkbox" type="checkbox" [(ngModel)]="paymentData.agree"
                                #agree1="ngModel" required> &nbsp;&nbsp;I agree to the
                            <span class="terms-link" [ngStyle]="{'color': colorHex}"
                                (click)="showTermsAndConditions(longContent)">Terms and Conditions</span>
                        </label>
                    </div>

                    <ng-template #longContent let-modal>
                        <div class="modal-header">
                            <h4 class="modal-title" [ngStyle]="{'color': colorHex}">Terms & Conditions</h4>
                        </div>
                        <div class="modal-body">
                            <div [innerHtml]="termsAndConditions"></div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-light" (click)="modal.close('Close click')"
                                [ngStyle]="{'color': colorHex}">Close</button>
                        </div>
                    </ng-template>

                </div>

                <div class="payment-buttons">
                    <form action="submit_to_direct_post_api.php" method="post">
                        <div id="applepaybutton" style="width: 90%; margin: auto;"></div>
                    </form>

                    <form action="submit_to_direct_post_api.php" method="post">
                        <div id="googlepaybutton" style="width: 90%; margin: auto;"></div>
                    </form>

                    <button class="btn submit-button" id="demoPayButton" type="button"
                        [ngStyle]="{'background-color': colorHex}" (click)="this.submittedButtonPressed = true; displayLoadingImage()"
                        [disabled]="!paymentData.agree || zipCode.invalid || (type == 'paymentPage' && (cardErr.checkname.flag || cardErr.ccnumber.flag || cardErr.ccexp.flag || cardErr.cvv.flag || this.submittedButtonPressed))">
                        Pay {{payloadData.amountDue | currency}} with Card
                    </button>

                </div>

                <div class="loading-spinner" *ngIf="isLoading"></div>
                <div class="loading-overlay" *ngIf="isLoading"></div>

            </div>

            <div class="confirmation-page" *ngIf="type=='confirmationPage'">
                <div class="logo-container">
                    <img class="logo" src='{{payloadData.logoUrl}}'>
                </div>

                <div class="payment-response">
                    <img class="confirmation-image" *ngIf="response.status!='FAIL'" src='ui/assets/img/otp/greencheckcircle.svg'>
                    <img class="confirmation-image" *ngIf="response.status=='FAIL'" src='ui/assets/img/otp/redcrosscircle.svg'>
                    <div *ngIf="response.status!='FAIL'" class="thank-you">Thank you for your payment!</div>
                    <div *ngIf="response.status=='FAIL'" class="thank-you">Transaction was declined.</div>
                    <div *ngIf="response.status=='FAIL'"><small>{{response.errors.ERROR_RESPONSE}}</small></div>
                </div>

                <div class="confirmation-details">
                    <div *ngIf="response.status!='FAIL'" class="confirmation-responses">
                        <div>Confirmation Number</div>
                        <div class="confirmation-details-response">{{response.nmiTransactionId}}</div>
                    </div>
                    <div class="confirmation-responses">
                        <div>Payment Date</div>
                        <div class="confirmation-details-response">{{response.submittedDate}}</div>
                    </div>
                    <div class="confirmation-responses">
                        <div>Submitted Time</div>
                        <div class="confirmation-details-response">{{response.submittedTime}}</div>
                    </div>
                    <div class="confirmation-responses">
                        <div>Total Payment</div>
                        <div class="confirmation-details-response">{{payloadData.amountDue | currency}}</div>
                    </div>
                    <div class="confirmation-response-last">
                        <div>Payment Method</div>
                        <div class="confirmation-details-response">{{paymentMethod}}</div>
                    </div>
                </div>

                <div class="footer">
                    <div class="take-screenshot">Please take a screenshot of this <br> page for your personal records.</div>
                </div>

                <!--<div class="text-or-email-confirmation">
                    <div *ngIf="confirmationComplete" class="confirmation-text">Your confirmation has been sent. Thank
                        you!
                    </div>

                    <div *ngIf="!confirmationComplete">
                        <div class="confirmation-text">If you would like to receive a confirmation message, please enter
                            your
                            Email Address or Phone Number below.</div>
                        <div class="input-flex align-center">
                            <div class="form-group">
                                <div>
                                    <input name="email" class="form-custom" placeholder="Email Address" type="email"
                                        [(ngModel)]="contact.email" #email="ngModel"
                                        pattern="[a-z0-9A-Z._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$">
                                </div>
                                <div *ngIf="email.invalid || email.invalid && (email.dirty || email.touched)" class="invalid-feedback">
                                <div *ngIf="email.errors.pattern">Invalid Email Address</div>
                            </div>
                            </div>
                            <div class="form-group">
                                <input name="phoneNumber" class="form-custom" placeholder="Phone Number" appPhoneMask
                                    type="tel" [(ngModel)]="contact.phoneNumber" maxlength="14">
                                <div *ngIf="!validUSphoneNumber && !onSubmitLoader" class="invalid-feedback">
                                <div *ngIf="!validUSphoneNumber">Invalid Phone Number</div>
                            </div>
                            </div>
                            <div class="confirmation-text-sms">SMS charges may apply.</div>
                        </div>

                        <button class="btn confirmation-submit-button" type="button"
                            [ngStyle]="{'background-color': colorHex}" (click)="doReceipt()">
                            Submit
                        </button>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>
